import { useTranslation } from '@pancakeswap/localization'
import { Token } from '@pancakeswap/sdk'
import { Box, Flex, Text } from '@pancakeswap/uikit'
import { useState } from 'react'
import styled from 'styled-components'
import PreviousBetsTable from '../PreviousBetsTable'

interface DesktopBetsTableProps {
  account: string
  token: Token
  api: string
}

const StyledTableBorder = styled.div`
  /* border: 1px solid ${({ theme }) => theme.colors.white10}; */
  height: fit-content;
`

const DesktopBetsTable: React.FC<React.PropsWithChildren<DesktopBetsTableProps>> = ({ account, token, api }) => {
  const { t } = useTranslation()
  const [isOpen, setIsOpen] = useState(true)

  const handleToggle = () => setIsOpen(!isOpen)

  return (
    <Box p="24px" pt="16px">
      <FlexContainer
        alignItems="center"
        justifyContent="space-between"
        // px="24px"
        // py="32px"
        // borderBottom="1px solid"
        // borderColor="cardBorder"
        style={{ cursor: 'pointer' }}
        onClick={handleToggle}
      >
        <Text className="label" as="h5" color="#FFFFFF" fontWeight="700" fontSize="14px">
          {t('Last %num% Bets', { num: 5 })}
        </Text>
        {/* {isOpen ? (
          <img alt="arr" src="/images/leaderboard/arr.svg" />
        ) : (
          <img alt="arr" style={{ transform: 'rotate(180deg)' }} src="/images/leaderboard/arr.svg" />
        )} */}
      </FlexContainer>
      <StyledTableBorder>
        {account && isOpen && <PreviousBetsTable token={token} api={api} account={account} />}
      </StyledTableBorder>
    </Box>
  )
}
const FlexContainer = styled(Flex)`
  margin-bottom: 8px;
  align-items: center;
`
export default DesktopBetsTable
